import createClient, { type Middleware } from 'openapi-fetch';
import type { components, paths } from './schema';
import { getToken, refreshToken } from '../auth/tokenSource';

export type Schemas = components['schemas'];

/** Když se nepodaří získat platný token — AuthGate pak ukáže přihlášení. */
export const unauthorized = new EventTarget();

const auth: Middleware = {
  async onRequest({ request }) {
    const token = await getToken();
    if (token) {
      request.headers.set('Authorization', `Bearer ${token}`);
    }

    return request;
  },

  async onResponse({ request, response }) {
    if (response.status !== 401) {
      return response;
    }

    // Token mohl mezitim vyprset. Zopakovat jde bezpecne jen cteni - u zapisu
    // nevime, jestli se neprovedl, a opakovanim bychom ho mohli udelat dvakrat.
    if (request.method === 'GET') {
      const fresh = await refreshToken().catch(() => null);
      if (fresh) {
        const retry = new Request(request, { headers: new Headers(request.headers) });
        retry.headers.set('Authorization', `Bearer ${fresh}`);

        const again = await fetch(retry);
        if (again.status !== 401) {
          return again;
        }
      }
    }

    unauthorized.dispatchEvent(new Event('unauthorized'));
    return response;
  },
};

export const api = createClient<paths>({ baseUrl: '' });
api.use(auth);

/**
 * Chyba z API ve tvaru ProblemDetails. `detail` je česky a je určený pro člověka —
 * frontend ho má ukázat, ne si vymýšlet vlastní text.
 */
export function problemMessage(error: unknown): string {
  if (error && typeof error === 'object' && 'detail' in error && typeof error.detail === 'string') {
    return error.detail;
  }

  return 'Něco se nepovedlo. Zkuste to prosím znovu.';
}
